<template>
  <div>
    <div>
      <div v-if="!dateValue.name" :class="dateValue.divClass">
        <p :class="dateValue.style.class">
          {{ dateValue.value }}
        </p>
      </div>

      <div v-else :class="dateValue.divClass">
        <div :class="dateValue.style.divClassFirst">
          <p :class="dateValue.style.class">
            {{ dateValue.name }}
          </p>
        </div>
        <div :class="dateValue.style.divClassSecond">
          <p :class="dateValue.style.class">
            {{ dateValue.value }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    dateData: {
      type: String
    }
  },
  computed: {
    dateValue() {
      let change = this.dateData;
      for (const element of change) {
        element.value = moment(element.value).format("DD/MM/YY");
      }
      return change;
    }
  }
};
</script>

<style lang="scss"></style>
